export var MessageType;
(function (MessageType) {
    MessageType["Assistant"] = "assistant";
    MessageType["User"] = "user";
})(MessageType || (MessageType = {}));
